<template>
   <div class="sz-cash-input-box">
      <el-input-number class="sz-cash-input-item" @input="keyUpEvent($event)" :disabled="disabled" v-model="cashObj.a" :min="0" :max="9" :precision="0" size="mini" :controls="false" @change="changeFn($event,'a')"/>百万
      <el-input-number class="sz-cash-input-item" @keyup="keyUpEvent($event)" :disabled="disabled" v-model="cashObj.b" :min="0" :max="9" :precision="0" size="mini" :controls="false" @change="changeFn($event,'b')"/>十万
      <el-input-number class="sz-cash-input-item" @keyup="keyUpEvent($event)" :disabled="disabled" v-model="cashObj.c" :min="0" :max="9" :precision="0" size="mini" :controls="false" @change="changeFn($event,'c')"/>万
      <el-input-number class="sz-cash-input-item" @keyup="keyUpEvent($event)" :disabled="disabled" v-model="cashObj.d" :min="0" :max="9" :precision="0" size="mini" :controls="false" @change="changeFn($event,'d')"/>千
      <el-input-number class="sz-cash-input-item" @keyup="keyUpEvent($event)" :disabled="disabled" v-model="cashObj.e" :min="0" :max="9" :precision="0" size="mini" :controls="false" @change="changeFn($event,'e')"/>百
      <el-input-number class="sz-cash-input-item" @keyup="keyUpEvent($event)" :disabled="disabled" v-model="cashObj.f" :min="0" :max="9" :precision="0" size="mini" :controls="false" @change="changeFn($event,'f')"/>十
      <el-input-number class="sz-cash-input-item" @keyup="keyUpEvent($event)" :disabled="disabled" v-model="cashObj.g" :min="0" :max="9" :precision="0" size="mini" :controls="false" @change="changeFn($event,'g')"/>元
      <el-input-number class="sz-cash-input-item" @keyup="keyUpEvent($event)" :disabled="disabled" v-model="cashObj.i" :min="0" :max="9" :precision="0" size="mini" :controls="false" @change="changeFn($event,'i')"/>角
      <el-input-number class="sz-cash-input-item" @keyup="keyUpEvent($event)" :disabled="disabled" v-model="cashObj.j" :min="0" :max="9" :precision="0" size="mini" :controls="false" @change="changeFn($event,'j')"/>分
   </div>
</template>

<script lang="ts">
import { defineComponent, computed, PropType, onMounted, reactive } from "vue";
export default defineComponent({
    props: {
        /**
         * @param {Object} 当前表单的值
         */
        modelValue: {
            type: Number,
            default: (): any => {
                return 0;
            },
        },
		/**
		 * 是否禁用
		 */
		disabled: {
			type: Boolean,
			default: false,
		},
    },
    setup(props, ctx:any) {
        let cashObj: any = reactive({
			a:'',
            b:'',
            c:'',
            d:'',
			e:'',
            f:'',
            g:'',
            h:'.',
			i:'',
            j:'',
		});
        // 输入金额截取
        const getCashFn = (val: any)=>{
            let valArr = [];
            if(typeof(val) === 'string'){
                val = Number(val);
            }
            valArr = val.toFixed(2).split('').reverse();
            cashObj.a = valArr[9];
            cashObj.b = valArr[8];
            cashObj.c = valArr[7];
            cashObj.d = valArr[6];
            cashObj.e = valArr[5];
            cashObj.f = valArr[4];
            cashObj.g = valArr[3];
            cashObj.h = valArr[2];
            cashObj.i = valArr[1];
            cashObj.j = valArr[0];
        };

        const changeFn = (newVal: any, type: any) => {
            let result:any = [];
            Object.values(cashObj).forEach((item:any)=>{
                result.push(item === undefined?0:item);
            });
            ctx.emit('update:modelValue',Number(result.join('')));
        }
        const keyUpEvent = (e:any)=>{
            console.log(e);
        }
        onMounted(() => {
            getCashFn(props.modelValue);
        });

        return {
            cashObj,
            changeFn,
            keyUpEvent
        };
    },
});
</script>
<style lang='less' scoped>
.sz-cash-input-box{
    .sz-cash-input-item{ width: 36px; margin-right: 4px; }
}
</style>